import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getUserInfo, addUserRole, deleteUserRole, getUserRoles } from "actions/user";
import { getSchoolServices } from 'actions/schools';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Checkbox } from '@haldor/ui';
import { Spinner } from 'UI';
import { getActiveSchool } from 'helpers/localstorage';
import User from '_class/User';
import moment from 'moment';

var UserRoles = /*#__PURE__*/function (_Component) {
  _inherits(UserRoles, _Component);

  var _super = _createSuper(UserRoles);

  function UserRoles(props) {
    var _this;

    _classCallCheck(this, UserRoles);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.user);
      var school = user.getActiveSchool();

      _this.props.getSchoolServices(school.id).then(function () {
        var foundSMS = _this.props.schoolServices.find(function (service) {
          return service.serviceId == 'HALDOR_SMS' && moment(service.serviceEnd).isSameOrAfter(moment(), 'day');
        });

        if (foundSMS != null) {
          var roles = _this.state.roles;
          roles.push({
            name: "SMS_ADMIN",
            staffInRole: false,
            synced: false,
            adminView: true
          });

          _this.setState({
            roles: roles
          });
        }

        _this.loadRoleStatus();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "loadRoleStatus", function () {
      var roles = _this.state.roles.map(function (role) {
        return _objectSpread(_objectSpread({}, role), {}, {
          staffInRole: _this.staffInRole(role.name),
          synced: _this.roleSynced(role.name)
        });
      });

      _this.setState({
        roles: roles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCheckboxClick", function (roleId, value, synced) {
      if (value) {
        _this.props.addUserRole(_this.props.currentStaff.userId, roleId).then(function () {
          _this.props.getUserRoles(_this.props.currentStaff.id).then(function () {
            var roles = _this.state.roles;

            _this.state.roles.forEach(function (role) {
              if (role.name == roleId) {
                role.staffInRole = value;
              }
            });

            _this.setState({
              roles: roles
            });
          });
        });
      } else {
        _this.props.deleteUserRole(_this.props.currentStaff.userId, roleId).then(function () {
          _this.props.getUserRoles(_this.props.currentStaff.id).then(function () {
            var roles = _this.state.roles;

            _this.state.roles.forEach(function (role) {
              if (role.name == roleId) {
                role.staffInRole = value;
              }
            });

            _this.setState({
              roles: roles
            });
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderRolesRow", function (role) {
      var translate = _this.props.translate;
      return role.staffInRole && !role.adminView || _this.isCurrentUserAdmin() ? /*#__PURE__*/React.createElement(RowItem, {
        key: role.name
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: translate('name')
      }, _this.isCurrentUserAdmin() ? /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(value) {
          return _this.onCheckboxClick(role.name, value, role.synced);
        },
        value: role.staffInRole,
        disabled: role.synced
      }) : null, translate(role.name.toUpperCase()))) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "staffInRole", function (role) {
      if (_this.props.roles != null && _this.props.roles.length > 0) {
        var foundRole = _this.props.roles.find(function (r) {
          return r.roleId.toUpperCase() == role && r.referenceId == _this.props.activeSchool;
        });

        if (foundRole != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "roleSynced", function (role) {
      if (role.toUpperCase() == 'TEACHER') {
        return true;
      }

      if (_this.props.roles != null && _this.props.roles.length > 0) {
        var foundRole = _this.props.roles.find(function (r) {
          return r.roleId.toUpperCase() == role && r.referenceId == _this.props.activeSchool;
        });

        if (foundRole != null) {
          return foundRole.synced;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "isCurrentUserAdmin", function () {
      if (_this.props.currentUser.roles != null && _this.props.currentUser.roles.length > 0) {
        var schoolAdmin = _this.props.currentUser.roles.find(function (role) {
          return role.roleId.toUpperCase() == "SCHOOL_ADMINISTRATOR" && role.referenceId == _this.props.activeSchool || role.roleId.toUpperCase() == "SYSADMIN" && role.referenceId == _this.props.activeSchool;
        });

        if (schoolAdmin != null) {
          return true;
        }
      }

      return false;
    });

    _this.state = {
      loading: false,
      roles: [{
        name: "TEACHER",
        staffInRole: false,
        synced: true,
        adminView: false
      }, {
        name: "MENTOR",
        staffInRole: false,
        synced: false,
        adminView: false
      }, {
        name: "SPECIAL_PEDAGOGUE",
        staffInRole: false,
        synced: false,
        adminView: false
      }, {
        name: "COURSE_ADMINISTRATOR",
        staffInRole: false,
        synced: false,
        adminView: false
      }, {
        name: "CONVERSATION_ADMIN",
        staffInRole: false,
        synced: false,
        adminView: true
      }, {
        name: "SCHOOL_LEADER",
        staffInRole: false,
        synced: false,
        adminView: true
      }]
    };
    return _this;
  }

  _createClass(UserRoles, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var currentUser = this.props.currentUser;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      var school = currentUser.schools.find(function (school) {
        return school.id == getActiveSchool(currentUser.id);
      });
      var user = new User(currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, this.props.translate('roles-for'), ' ' + school.title, /*#__PURE__*/React.createElement(DataList, {
        data: this.state.roles.filter(function (role) {
          if (user.isStudent()) {
            return role.name.indexOf('ADMIN') == -1;
          }

          return true;
        }),
        renderRow: this.renderRolesRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results'));
        }
      }));
    }
  }]);

  return UserRoles;
}(Component);

function mapStateToProps(state) {
  return {
    schoolServices: state.School.schoolServices,
    user: state.user.currentUser,
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    activeSchool: state.user.activeSchool,
    roles: state.user.roles
  };
}

export default connect(mapStateToProps, {
  getUserInfo: getUserInfo,
  addUserRole: addUserRole,
  deleteUserRole: deleteUserRole,
  getUserRoles: getUserRoles,
  getSchoolServices: getSchoolServices
})(UserRoles);